import { alpha, Chip, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { RiskStatus } from '@app/src/types/resourceExplorer'
import { getRiskColor, getRiskStatusTranslationKey } from '@app/src/utils/riskStatusHelpers'
import ParentCellOrFragment from './ParentCellOrFragment'

export interface SimpleRiskChipCellProps {
  riskStatus?: RiskStatus
  disableCell?: boolean
  disabled?: boolean
  onClick?: () => void
}

const SimpleRiskChipCell: React.FC<SimpleRiskChipCellProps> = ({ riskStatus, disableCell, disabled, onClick }) => {
  const { formatMessage } = useIntl()

  const color = useMemo(() => {
    if (disabled) return alpha('#000', 0.04)
    const riskColor = getRiskColor(riskStatus)
    return riskColor === 'transparent' ? alpha('#000', 0.04) : riskColor
  }, [riskStatus, disabled])

  if (!riskStatus) {
    return (
      <ParentCellOrFragment disableCell={disableCell}>
        <Typography variant="body2" color="text.disabled">
          {formatMessage({ id: 'schemas.risk.notAvailable' })}
        </Typography>
      </ParentCellOrFragment>
    )
  }

  return (
    <ParentCellOrFragment disableCell={disableCell}>
      <Chip
        label={formatMessage({
          id: riskStatus ? getRiskStatusTranslationKey(riskStatus) : 'schemas.risk.notAvailable',
        })}
        size="small"
        disabled={disabled}
        onClick={onClick}
        clickable={Boolean(onClick)}
        sx={{
          color: riskStatus === RiskStatus.Extreme && !disabled ? 'primary.contrastText' : 'primary.main',
          '& .MuiChip-label': {
            bgcolor: color,
            border: '2px solid',
            borderColor: color,
            borderRadius: 1,
          },
        }}
      />
    </ParentCellOrFragment>
  )
}

export default SimpleRiskChipCell
